export class Tab {
    id: number;
    name: string;
    type: string;
    pivot: any;
    originalPivot: any;

    constructor(tabName, tabID = 0, tabType = null) {
        this.name = tabName;
        this.id = tabID;
        this.type = tabType;
    }
}
